import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function UpdateSection() {
  const list = comics.slice(0, 8);
  return (
    <section id="update" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            align="left"
            eyebrow="本周最新上架"
            title="今日更新"
            desc="软萌新作与甜宠连载抢先看，每天都有新的心动等你发现。"
          />
          <Link
            to="/category/all"
            className="mb-10 flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
          >
            查看全部更新
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {list.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}